// extracted by mini-css-extract-plugin
export default {"table":"DomainSearch_table__uYvmL","container":"DomainSearch_container__kyd08"};